<ng-container *ngIf="isAllowedRegion">
  <app-exit-page [showExitConfirmation]="showExitConfirmation"></app-exit-page>
  <app-loading></app-loading>
<router-outlet></router-outlet>
</ng-container>

<app-error-region *ngIf="!isAllowedRegion"> </app-error-region>
<div id="connection" class="index-dialog connection-dialog" *ngIf="status === 'OFFLINE'">
  <div class="connection">
    <div class="error-dialog-box">
      <p class="error-dialog-box-message">You have low internet connection, please try again later.</p>
      <div class="error-dialog-box-buttons horizontal-focusable-container" data-blocked>
        <button id="exitButton" onclick="appExit()" class="button-exit primary-button focusable-element"
          type="button">Exit</button>
      </div>
    </div>
  </div>
</div>